import httpService from './httpService';

export const unacceptedAgreements = () => {
  let endpoint = httpService.getEndpointURL(`/Users/agreements/unaccepted`);
  return httpService.get(endpoint);
};

export const acceptAgreements = (agreementId: number) => {
  let endpoint = httpService.getEndpointURL(`/Users/agreements/${agreementId}/accept`);
  return httpService.post(endpoint);
};

export const getAgreement = (id: number) => {
  let endpoint = httpService.getEndpointURL(`/Agreements/${id}`);
  return httpService.get(endpoint);
};

export const downloadAgreements = (agreementId: number) => {
  let endpoint = httpService.getEndpointURL(`/Documents/Download/${agreementId}`);
  return httpService.get(endpoint).then(function (response) {
    const data = response.data;
    return new Uint8Array(data);
  });
};
